import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';


export const getAnalyticsDay = createAsyncThunk(
  "analytics/getAnalyticsDay",
  async ({ token, type, onlyMy,range }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/day-wise`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy,range
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);


export const getAnalyticsMonthly = createAsyncThunk(
  "analytics/getAnalyticsmonthly",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/month-wise`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const getAnalyticsWeekly = createAsyncThunk(
  "analytics/getAnalyticsWeekly",
  async ({ token, type, onlyMy, range }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/weekdays`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, 
            onlyMy,
            range,
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const fetchReportByKey = createAsyncThunk(
  "analytics/ReportKey",
  async ({ token, type, offset, limit, key, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/by-key/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, offset, limit, startDate, endDate
          }

        }
      );

      if (response.data.status) {
        return { offset, response: response.data.response };
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const fetchReport = createAsyncThunk(
  "analytics/Report",
  async ({ token, type, offset, limit, startDate, endDate }, { rejectWithValue }) => {
    console.log(startDate, endDate)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/reports`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, offset, limit, startDate, endDate
          }

        }
      );

      if (response.data.status) {
        return { offset, response: response.data.response };
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const MostClickedPdf = createAsyncThunk(
  "analytics/MostClickedPdf",
  async ({ token, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/most-clicked-pdf`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const MostClickedBio = createAsyncThunk(
  "analytics/MostClickedBio",
  async ({ token, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/most-clicked-bio`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const MostClickedSs = createAsyncThunk(
  "analytics/MostClickedSs",
  async ({ token, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/most-clicked-ss`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const MostClickedLink = createAsyncThunk(
  "analytics/MostClickedLinks",
  async ({ token, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/most-clicked-links`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const getAnalyticsDevice = createAsyncThunk(
  "analytics/getAnalyticsDevice",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/device`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const getAnalyticsOs = createAsyncThunk(
  "analytics/getAnalyticsOs",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/os`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);


export const getAnalyticsCity = createAsyncThunk(
  "analytics/getAnalyticsCity",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/city`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const getAnalyticsState = createAsyncThunk(
  "analytics/getAnalyticsState",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/state`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const getAnalyticsBrowser = createAsyncThunk(
  "analytics/getAnalyticsBrowser",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/browser`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const getAnalyticsCountry = createAsyncThunk(
  "analytics/getAnalyticsCountry",
  async ({ token, type, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/analytics/country`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            type, onlyMy
          }

        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    osData: [],
    countryData: [],
    deviceData: [],
    browserData: [],
    osData: [],
    stateData: [],
    cityData: [],
    weeklyLinkData: [],
    mostClickedLink: [],
    mostClickedBio: [],
    mostClickedPdf: [],
    mostClickedSs: [],
    reportData: [],
    reportDataKey: [],
    dayWiseData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnalyticsCountry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.countryData = action.payload;
      })
      .addCase(getAnalyticsCountry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.countryData = action.payload;
        state.countryData = []

      })
      .addCase(getAnalyticsBrowser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsBrowser.fulfilled, (state, action) => {
        state.loading = false;
        state.browserData = action.payload;
      })
      .addCase(getAnalyticsBrowser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.browserData = []

      })
      .addCase(getAnalyticsOs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsOs.fulfilled, (state, action) => {
        state.loading = false;
        state.osData = action.payload;
      })
      .addCase(getAnalyticsOs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.osData = []

      })
      .addCase(getAnalyticsDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceData = action.payload;
      })
      .addCase(getAnalyticsDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.deviceData = []

      })
      .addCase(MostClickedLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(MostClickedLink.fulfilled, (state, action) => {
        state.loading = false;
        state.mostClickedLink = action.payload;
      })
      .addCase(MostClickedLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.mostClickedLink = []

      })

      .addCase(MostClickedPdf.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(MostClickedPdf.fulfilled, (state, action) => {
        state.loading = false;
        state.mostClickedPdf = action.payload;
      })
      .addCase(MostClickedPdf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.mostClickedPdf = []

      })

      .addCase(MostClickedSs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(MostClickedSs.fulfilled, (state, action) => {
        state.loading = false;
        state.mostClickedSs = action.payload;
      })
      .addCase(MostClickedSs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.mostClickedSs = []

      })

      .addCase(MostClickedBio.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(MostClickedBio.fulfilled, (state, action) => {
        state.loading = false;
        state.mostClickedBio = action.payload;
      })
      .addCase(MostClickedBio.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.mostClickedBio = []
      })
      .addCase(fetchReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.offset === 1) {
          state.reportData = action.payload.response

        } else {
          state.reportData = [...state.reportData, ...action.payload.response]

        }
        state.reportDataKey = []
      })
      .addCase(fetchReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // toast.error(action.payload)
        // state.reportData =[]
      })
      .addCase(fetchReportByKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReportByKey.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.offset === 1) {
          state.reportDataKey = action.payload.response

        } else {
          state.reportDataKey = [...state.reportDataKey, ...action.payload.response]

        }
      })
      .addCase(fetchReportByKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // toast.error(action.payload)
        // state.reportData =[]
      })
      .addCase(getAnalyticsState.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsState.fulfilled, (state, action) => {
        state.loading = false;
        state.stateData = action.payload;
      })
      .addCase(getAnalyticsState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.stateData = []

      })
      .addCase(getAnalyticsCity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsCity.fulfilled, (state, action) => {
        state.loading = false;
        state.cityData = action.payload;
      })
      .addCase(getAnalyticsCity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.cityData = []

      })
      .addCase(getAnalyticsWeekly.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsWeekly.fulfilled, (state, action) => {
        state.loading = false;
        state.weeklyLinkData = action.payload;
      })
      .addCase(getAnalyticsWeekly.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.weeklyLinkData = []

      })
      .addCase(getAnalyticsMonthly.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsMonthly.fulfilled, (state, action) => {
        state.loading = false;
        state.weeklyLinkData = action.payload;
      })
      .addCase(getAnalyticsMonthly.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.weeklyLinkData = []

      })
          .addCase(getAnalyticsDay.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsDay.fulfilled, (state, action) => {
        state.loading = false;
        state.dayWiseData = action.payload;
      })
      .addCase(getAnalyticsDay.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.dayWiseData = []

      })
  },
});

export default analyticsSlice.reducer;  